// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"547":"48d02676","582":"b9918f82"}[chunkId] + ".chunk.js";
};